import { config } from '../config'

/**
 * The shareable join link for a trip.
 *
 * Shape is fixed by the mobile apps' universal-link handlers — iOS
 * `SceneDelegate` and Android's manifest both claim `/appLink/joinTrip/{code}`
 * on the marketing host — so a link copied from the web opens straight into the
 * app. Changing it here silently breaks deep-linking on both.
 */
export const tripJoinUrl = (tripCode: string): string =>
	`${config.getOrbitUrl}/appLink/joinTrip/${encodeURIComponent(tripCode.trim())}`

/** The same link without its scheme — what we show in the invite dialog. */
export const tripJoinUrlDisplay = (tripCode: string): string =>
	tripJoinUrl(tripCode).replace(/^https?:\/\//, '')
